import React from 'react';
import { Divider } from 'snacks-design-system';

interface componentProps {
  className?: string;
  offsetSize?: string;
  offsetDir?: 't' | 'b' | 'y';
  label?: React.ReactNode;
  labelBgColor?: string;
  mode?: 'regular' | 'inverse';
  dataSctTrack?: string;
  qaSelector?: string;
}
const PIEDivider = (props: componentProps) => {
  return <Divider {...props} />;
};

export default PIEDivider;
